





















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { formatNum, formatTime } from '../../render';
import { IClientUsageList } from '@/store/home/stats/types';
import DataTable from '../../common/DataTable.vue';

const Stats = namespace('home/stats');

@Component({
  components: { DataTable },
})
export default class ClientUsageTable extends Vue {
  @Stats.State('clientUsageList') public list!: IClientUsageList;

  public timeHeaders = [
    { text: '组织', value: 'orgName' },
    { text: '用户', value: 'userName' },
    { text: '总时长(小时)', value: 'totalTime' },
  ];
  public countHeaders = [
    { text: '组织', value: 'orgName' },
    { text: '用户', value: 'userName' },
    { text: '总次数', value: 'totalCount' },
  ];

  // 时长排行
  public get timeItems() {
    return this.list.data.filter((item) => item.type === 1).map((item) => {
      const totalTime = formatTime(item.totalTime);
      return { ...item, totalTime };
    });
  }

  // 次数排行
  public get countItems() {
    return this.list.data.filter((item) => item.type === 2).map((item) => {
      const totalCount = formatNum(item.totalCount);
      return { ...item, totalCount };
    });
  }
}
